<template>
  <div class="article-comment">
    <div class="none" v-if="list.length===0">
      <img width="160px" height="160px" src="@/assets/none.png" alt="">
      <p>还没有人评论哦</p>
    </div>
    <van-list
      v-else
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="没有更多了"
    >
      <div
        class="item"
        v-for="item in list"
        :key="item.com_id.toString()"
      >
        <van-image
          round
          width="0.9rem"
          height="0.9rem"
          fit="fill"
          :src="item.aut_photo"
        />
        <div class="info">
          <p>
            <span class="name">{{ item.aut_name }}</span>
            <span class="zan" @click="toggleLike(item)">
              <span class="count">{{ item.like_count }}</span>
              <tt-icon :name="item.is_liking?'like-sel':'like'" />
            </span>
          </p>
          <p class="content">{{ item.content }}</p>
          <p>
            <span @click="$emit('onShowReply', item)" class="reply">{{item.reply_count||''}}回复 <i class="van-icon van-icon-arrow"></i></span>
            <span class="time">{{ item.pubdate | relTime }}</span>
          </p>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getCommentsOrReplys } from '@/api/article'
import { unCommentLikings, commentLikings } from '@/api/comment'
export default {
  name: 'ArticleComment',
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      offset: null
    }
  },
  activated () {
    this.list = []
    this.finished = false
    this.loading = true
    this.offset = null
    this.onLoad()
  },
  methods: {
    toggleLike (item) {
      (item.is_liking
        ? unCommentLikings(item.com_id)
        : commentLikings(item.com_id)).then(data => {
        item.is_liking = !item.is_liking
        item.like_count += item.is_liking ? 1 : -1
      })
    },
    async onLoad () {
      this.loading = true
      const data = await getCommentsOrReplys({
        type: 'a',
        source: this.$route.params.id,
        offset: this.offset
      })
      this.total = data.total_count
      this.list.push(...data.results)
      // 结束加载状态
      this.loading = false
      // 判断是否有数据
      if (data.last_id !== data.end_id) {
        this.offset = data.last_id
      } else {
        this.finished = true
      }
    }
  }
}
</script>
<style scoped lang="less">
.none {
  line-height: 1;
  padding: 10px 0;
  text-align: center;
  p {
    padding-top: 10px;
    color: #969799;
  }
}
.item {
  display: flex;
  padding: 10px 16px;
  .info {
    flex: 1;
    padding-left: 10px;
    width: 100%;
    overflow: hidden;
    p {
      padding: 5px 0;
      margin: 0;
    }
    .name {
      font-size: 15px;
    }
    .zan {
      float: right;
      display: flex;
      align-items: center;
      font-size: 14px;
      .count {
        margin-right: 10px;
        position: relative;
        top: 1px;
      }
    }
    .content {
      color: #666;
      font-size: 16px;
      word-break: break-all;
    }
    .reply {
      width: 60px;
      height: 25px;
      background: #F7F8FA;
      border-radius: 12px;
      display: inline-block;
      line-height: 25px;
      text-align: center;
      font-size: 12px;
      .van-icon {
        position: relative;
        top: 2px;
      }
    }
    .time {
      color: #999;
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
</style>
